// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.delete-modal {
    width: 420px;
    padding: 30px;
    position: relative;
    text-align: center;
}

.close-btn{
    position:absolute;
    top:15px;
    right:15px;
    border:none;
    background:none;
    cursor:pointer;
    font-size:20px;
}

.delete-icon{
    width:70px;
    height:70px;
    margin:auto;
    border-radius:50%;
    background:#ffe9e9;
    color:#dc2626;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:32px;
}

.delete-modal h2{
    margin:20px 0 10px;
}

.delete-modal p{
    color:#666;
    line-height:1.6;
}

.delete-actions{
    display:flex;
    justify-content:center;
    gap:15px;
    margin-top:30px;
}

.cancel-btn{
    padding:12px 24px;
    border:none;
    border-radius:8px;
    background:#ececec;
    cursor:pointer;
}

.delete-btn{
    padding:12px 24px;
    border:none;
    border-radius:8px;
    background:#dc2626;
    color:#fff;
    cursor:pointer;
}

.delete-btn:hover{
    background:#b91c1c;
}

.delete-error {
    margin-top: 16px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #fef2f2;
    color: #b91c1c;
    font-weight: 600;
}

.delete-actions button:disabled { cursor: not-allowed; opacity: .65; }
`, "",{"version":3,"sources":["webpack://./src/forms/DeleteConfirmation.css"],"names":[],"mappings":";;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA,kCAAkC,mBAAmB,EAAE,YAAY,EAAE","sourcesContent":["\r\n\r\n.delete-modal {\r\n    width: 420px;\r\n    padding: 30px;\r\n    position: relative;\r\n    text-align: center;\r\n}\r\n\r\n.close-btn{\r\n    position:absolute;\r\n    top:15px;\r\n    right:15px;\r\n    border:none;\r\n    background:none;\r\n    cursor:pointer;\r\n    font-size:20px;\r\n}\r\n\r\n.delete-icon{\r\n    width:70px;\r\n    height:70px;\r\n    margin:auto;\r\n    border-radius:50%;\r\n    background:#ffe9e9;\r\n    color:#dc2626;\r\n    display:flex;\r\n    align-items:center;\r\n    justify-content:center;\r\n    font-size:32px;\r\n}\r\n\r\n.delete-modal h2{\r\n    margin:20px 0 10px;\r\n}\r\n\r\n.delete-modal p{\r\n    color:#666;\r\n    line-height:1.6;\r\n}\r\n\r\n.delete-actions{\r\n    display:flex;\r\n    justify-content:center;\r\n    gap:15px;\r\n    margin-top:30px;\r\n}\r\n\r\n.cancel-btn{\r\n    padding:12px 24px;\r\n    border:none;\r\n    border-radius:8px;\r\n    background:#ececec;\r\n    cursor:pointer;\r\n}\r\n\r\n.delete-btn{\r\n    padding:12px 24px;\r\n    border:none;\r\n    border-radius:8px;\r\n    background:#dc2626;\r\n    color:#fff;\r\n    cursor:pointer;\r\n}\r\n\r\n.delete-btn:hover{\n    background:#b91c1c;\n}\n\n.delete-error {\n    margin-top: 16px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: #fef2f2;\n    color: #b91c1c;\n    font-weight: 600;\n}\n\n.delete-actions button:disabled { cursor: not-allowed; opacity: .65; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
